export const blockIconsTextformattingFolderNew = (
	<span className='material-symbols-outlined'>folder</span>
);
